import { Injectable } from '@angular/core';
import * as statesData from '../../../../src/assets/states_districts.json';
import { HttpClient } from '@angular/common/http';
import { API_URL } from 'common/constants/sm-constants';
import { branchListModel } from 'common/models/page-models/custom-model/branch.model';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { DataService } from '../base-data-services/data.service';

interface District {
  DistrictId: number;
  District: string;
  State: string;
  State_Type: string;
  State_Id: number;
}

@Injectable({ providedIn: 'root' })
export class DistrictDataService extends DataService<branchListModel> {
  constructor(protected ss: SystemService, protected http: SmApiService) {
    super(ss, API_URL.districtList, http);
  }

  createInstance(): branchListModel {
    return new branchListModel();
  }
}
